import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import "./MyTransactions.css";

function MyTransactions() {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const username = localStorage.getItem("username");

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      try {
        const tshQuery = query(
          collection(db, "tsh_transactions"),
          where("username", "==", username)
        );
        const usdtQuery = query(
          collection(db, "usdt_transactions"),
          where("username", "==", username)
        );

        const [tshSnap, usdtSnap] = await Promise.all([
          getDocs(tshQuery),
          getDocs(usdtQuery),
        ]);

        const combined = [
          ...tshSnap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            method: "TSH",
            type: "kuweka pesa",
          })),
          ...usdtSnap.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            method: "USDT",
            type: "kuweka pesa",
          })),
        ];

        // 🔽 Mpya juu
        combined.sort((a, b) => {
          const aTime = a.timestamp?.seconds || 0;
          const bTime = b.timestamp?.seconds || 0;
          return bTime - aTime;
        });

        setTransactions(combined);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      } finally {
        setLoading(false);
      }
    };

    if (username) fetchTransactions();
  }, [username]);

  // ===============================
  // 🏷️ STATUS LABELS (KISWAHILI)
  // ===============================
  const formatStatus = (status) => {
    switch (status) {
      case "processing":
        return "inachakata";
      case "success":
        return "muamala uliofanikiwa";
      case "rejected":
        return "imekataliwa";
      default:
        return status || "-";
    }
  };

  // ===============================
  // 🕒 FORMAT DATE
  // ===============================
  const formatDate = (timestamp) => {
    if (!timestamp?.seconds) return "-";
    const d = new Date(timestamp.seconds * 1000);
    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="transactions-container">
      <h2>Rekodi Za Kuweka Pesa</h2>

      {loading ? (
        <p>Inapakia...</p>
      ) : transactions.length === 0 ? (
        <p>Hakuna miamala iliyopatikana.</p>
      ) : (
        <table className="transactions-table">
          <thead>
            <tr>
              <th>Muda</th>
              <th>Aina</th>
              <th>Kiasi</th>
              <th>Hali</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((tx) => (
              <tr key={tx.id}>
                <td>{formatDate(tx.timestamp)}</td>
                <td>{tx.type}</td>
                <td>
                  {Number(tx.amount).toLocaleString()}{" "}
                  {tx.method === "TSH" ? "TZS" : "USDT"}
                </td>
                <td>
                  <span className={`status ${tx.status}`}>
                    {formatStatus(tx.status)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default MyTransactions;